import React from 'react';
import styles from './style.module.scss';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import classNames from 'classnames';
import { Logo } from 'assets';
export default function BrandLogo({ brandStyle, themeClass }) {
    const navigate = useNavigate();
    const navigateToMain = () => {
        navigate(routeConstant.login.path);
    };
    return (
        <div className={classNames(brandStyle && brandStyle, styles.brand, `${themeClass}FontColor`)} onClick={navigateToMain}>
            <img src={Logo}/>
        </div>
    );
}
